import React, { useRef, useEffect } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Form, Icon, Input, Button, Alert, Typography } from 'antd'
import { getTotpRegisterQrCode } from 'api/pgads'
const { Text } = Typography

const NormalLoginForm = ({
  style,
  className,
  onLogin,
  errorMessage,
  loading,
  twoFactorRegistration,
  apiTargetInfo,
  twoFactorRequired,
  twoFactorOptions,
  ...props
}) => {
  const qrCodeImageRef = useRef()
  console.log('apiTagetInfo is', apiTargetInfo)
  console.log('2factorOptiosn', twoFactorOptions)
  const { mode } = twoFactorOptions

  useEffect(() => {
    if (twoFactorRegistration != null) {
      getTotpRegisterQrCode(apiTargetInfo)(twoFactorRegistration).fork(
        console.log,
        resp => {
          if (resp.rawResp != null) {
            resp.rawResp.blob().then(data => {
              qrCodeImageRef.current.src = URL.createObjectURL(data)
            })
          }
          // console.log('got data', data)
        }
      )
    }
  }, [apiTargetInfo, twoFactorRegistration])
  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFields((err, values) => {
      if (!err) {
        onLogin && onLogin({ ...values, otpId: twoFactorOptions.otpId })
      }
    })
  }
  const userNameRef = useRef()
  useEffect(() => {
    if (userNameRef.current != null && userNameRef.current.input != null) {
      userNameRef.current.input.focus()
    }
  }, [])

  const { getFieldDecorator } = props.form
  return (
    <Form
      onSubmit={handleSubmit}
      className={className}
      css={{ width: '350px', minWidth: '350px', maxWidth: '350px', ...style }}
    >
      <Form.Item>
        {getFieldDecorator('username', {
          rules: [{ required: true, message: 'Please enter your user name' }],
        })(
          <Input
            ref={userNameRef}
            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="User Name"
          />
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('password', {
          rules: [{ required: true, message: 'Please enter your password' }],
        })(
          <Input
            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
            type="password"
            placeholder="Password"
          />
        )}
      </Form.Item>

      {twoFactorRegistration != null && (
        <React.Fragment>
          <Alert
            message=" Two Factor Authentication is required. 
              Please use any totp authenticator to scan the QR Code below. "
            type="info"
          />
          <img ref={qrCodeImageRef} />
          <Alert
            message=" Do not refresh this page. If you leave from this page you will have have to work with an user administrator to restart this process."
            type="warning"
          />
        </React.Fragment>
      )}

      {mode === 'emailOtp' && (
        <Alert
          message={
            <Text>
              We’ve sent a 6-digit verification code to your registered email.
              Enter the code below to continue. The code expires in 10 minutes.
            </Text>
          }
          type="info"
        />
      )}

      {(twoFactorRegistration != null || twoFactorRequired) && (
        <Form.Item>
          {getFieldDecorator('totpToken', {
            rules: [
              {
                required: true,
                message:
                  mode === 'emailOtp'
                    ? 'Please enter the otp sent to your email'
                    : 'Please enter the code from totp device',
              },
            ],
            // initialValue: userId,
          })(
            <Input
              placeholder={
                mode === 'emailOtp'
                  ? 'Emailed otp code'
                  : 'Authenticator TOTP Code'
              }
            />
          )}
        </Form.Item>
      )}

      <Form.Item>
        {/*
        {getFieldDecorator('remember', {
          valuePropName: 'checked',
          initialValue: true,
        })(<Checkbox>Remember me</Checkbox>)}
        <a className="login-form-forgot" css={{ float: 'right' }} href="">
          Forgot password
        </a>
        */}
        {errorMessage && <Alert message={errorMessage} type="error" />}
        <Button
          type="primary"
          htmlType="submit"
          css={{ width: '100%' }}
          loading={loading}
        >
          Log in
        </Button>
        {/*  Or <a href="">register now!</a> */}
      </Form.Item>
    </Form>
  )
}

export default Form.create({ name: 'normal_login' })(NormalLoginForm)
